import React, {useState, useEffect} from 'react';
import {useTranslation} from "react-i18next";
import {Link, useNavigate, useLocation} from "react-router-dom";
import '../../scss/tabs.scss';
import instance from "../../api/axios";
import {Cookies} from "react-cookie";

const AmeriaResult = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [loading, setLoading] = useState(true);

    const transactionId = queryParams.get('transactionId');
    const paymentId = queryParams.get('paymentId');
    const status = queryParams.get('status');
    const errorMessage = queryParams.get('errorMessage') ?? '';
    console.log('????????', transactionId);


    let integerPart = null;
    if (transactionId) {
        const regex = /-(\d+)$/;
        const match = transactionId.match(regex);
        integerPart = match ? match[1] : null;
        console.log(integerPart);

    }

    console.log(integerPart);

    let url = process.env.REACT_APP_BASE_URL;

    const [order, setOrder] = useState('');
    const [email, setEmail] = useState('');
    const {t, i18n} = useTranslation();
    const cookies = new Cookies();

    const getOrderInfo = async () => {
        try {
            const response = await instance.get(`${url}/abio/public/cart/resetOrder`, {
                headers: {
                    'X_ORDER_XSRF_TOKEN': cookies.get('ORDER_XSRF_TOKEN'),
                },
                params: {
                    orderId: integerPart,
                    paymentID: paymentId,
                    transactionId: transactionId
                }
            });
            setOrder(response.data.id);
            setEmail(response.data.email);
        } catch (error) {
            console.error('Error fetching order info:', error);
        } finally {
            setLoading(false);
        }
    }


    useEffect(() => {
        getOrderInfo();
    }, []);

    return (
        <div className="payment-result-page">
            {/* Inline CSS Loader */}
            <style>
                {`
                .loadingBox {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    padding: 30px;
                    text-align: center;
                }

                .spinner {
                    width: 40px;
                    height: 40px;
                    border: 4px solid #ddd;
                    border-top-color: #5a8dee;
                    border-radius: 50%;
                    animation: spin 0.6s linear infinite;
                    margin-bottom: 10px;
                }

                @keyframes spin {
                    to { transform: rotate(360deg); }
                }
            `}
            </style>

            {loading ? (
                <div className="loadingBox">
                    <div className="spinner"></div>
                    <p>{t("Tabs.waiting")}</p>
                </div>
            ) : (
                <div className={status === 'success' ? 'success' : 'fail'}>
                    {status === 'success' ? (
                        order ? (
                            <>
                                <div className='modalCont'>
                                    <h2>{t("Tabs.thanks")}</h2>
                                </div>
                                <div className="modalText">
                                    {t("Tabs.thanksdetail1")} <span>{order}</span>
                                    {t("Tabs.thanksdetail2")} {email} {t("Tabs.thanksdetail3")}
                                </div>
                                <Link to={`/${i18n.language}`}>
                                    <button className="continuShop">{t("shop.continue")}</button>
                                </Link>
                            </>
                        ) : (
                            <>
                                <div className='modalCont'>
                                    <h2 className='errortext'>{t("Tabs.thankserror")}</h2>
                                </div>
                                <Link to={`/${i18n.language}`}>
                                    <button className="continuShop">{t("shop.continue")}</button>
                                </Link>
                            </>
                        )
                    ) : (
                        <>
                            <div className="errortext">
                                {t("Tabs.fail")} {order} {t("Tabs.fail1")}
                            </div>
                            <div className="errortext">
                                {t("Tabs.faildetail2")} {email} {t("Tabs.faildetail3")}
                            </div>
                            {errorMessage && (
                                <div className="errortext">
                                    {t("Tabs.errorMessage")}: {errorMessage}
                                </div>
                            )}
                            <Link to={`/${i18n.language}`}>
                                <button className="continuShop">
                                    {t("shop.continue")}
                                </button>
                            </Link>
                        </>
                    )}
                </div>
            )}
        </div>
    );

}

export {AmeriaResult};